The response from the `updateUnpostedPositionProfile` mutation.
